import styles from "./Tabs.module.scss";
import { ComponentType } from "react";
import { getTabTestId } from "@/constants/test-ids";

interface TabProps {
  label: string;
  Icon?: ComponentType;
  isActive: boolean;
  onClick: () => void;
  tabClassName?: string;
  activeTabClassName?: string;
}

const Tab = ({
  label,
  Icon,
  isActive,
  onClick,
  tabClassName,
  activeTabClassName,
}: TabProps) => {
  return (
    <div
      className={`${styles.tab} ${tabClassName} ${isActive ? `${styles.active} ${activeTabClassName}` : ""}`}
      onClick={onClick}
      // Funnily enough intercom product tour understands data-tabid property for some reason
      data-tabid={`${label}-tab`}
      role="presentation"
      data-testid={getTabTestId(label)}
    >
      {Icon && (
        <span className={styles.icon}>
          <Icon />
        </span>
      )}
      <label>{label}</label>
    </div>
  );
};

export default Tab;
